import { createSlice } from "@reduxjs/toolkit";
const initialState = { eotBalance: "0", pob: [] };
const ritualSlice = createSlice({ name: "ritual", initialState, reducers: {
  setEotBalance(state, action) { state.eotBalance = action.payload; },
  setPoB(state, action) { state.pob = action.payload; }
}});
export const { setEotBalance, setPoB } = ritualSlice.actions;
export default ritualSlice.reducer;
